module.exports = __webpack_public_path__ + "static/media/accessoires-gants.2e9086a3.jpg";